<script setup>
import AudienceForm from '@frontJs/components/forms/projectManagement/sea/AudienceForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const {
    googleAdsAudience,
    googleAdsAudienceTypes,
    googleAdsAudienceCustomerTypeCategories,
    tenant,
} = defineProps({
    tenant: {
        type: Object,
        required: true,
    },
    googleAdsAudience: {
        type: Object,
        required: false,
    },
    googleAdsAudienceTypes: {
        type: Array,
        required: true,
    },
    googleAdsAudienceCustomerTypeCategories: {
        type: Array,
        required: true,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title v-if="googleAdsAudience">
            Mettre à jour l'audience #{{ googleAdsAudience.id }} - Audiences SEA
            - Gestion de projet - Datakepler
        </title>

        <title v-else>
            Créer une audience - Audiences - SEA - Gestion de projet -
            Datakepler
        </title>
    </Head>

    <PageTitle v-if="googleAdsAudience" :tenant-name="tenant.name">
        Gestion de projet - SEA - Audiences - Mettre à jour l'audience #{{
            googleAdsAudience.id
        }}
    </PageTitle>

    <PageTitle v-else :tenant-name="tenant.name">
        Gestion de projet - SEA - Audiences - Créer une audience
    </PageTitle>

    <AudienceForm
        :tenant="tenant"
        :google-ads-audience="googleAdsAudience"
        :google-ads-audience-types="googleAdsAudienceTypes"
        :google-ads-audience-customer-type-categories="
            googleAdsAudienceCustomerTypeCategories
        "
    />
</template>
